import React from "react"

import { useClipboard } from "@atos6/hooks"
import { Button } from "@atos6/ui"

type Props = {
  value: string
}

export function ButtonCopyClipboard(props: Props) {
  const [copied, copy] = useClipboard()

  return (
    <Button onClick={() => copy(props.value)}>
      {copied ? "Link Copiado" : "Copiar link"}
    </Button>
  )
}
